/**
 * Class-specific combat feature calculations.
 */

/**
 * Calculate sneak attack dice for a rogue.
 * Formula: ceil(rogueLevel / 2) d6s
 *
 * Level 1-2: 1d6
 * Level 3-4: 2d6
 * Level 5-6: 3d6
 * etc.
 */
export function calculateSneakAttackDice(rogueLevel: number): { dice: string; diceCount: number } {
  const diceCount = Math.ceil(rogueLevel / 2);
  return {
    dice: `${diceCount}d6`,
    diceCount,
  };
}
